import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllItemUserSuccess,
  getAllItemUserFailed,
  GET_ALL_ITEM_USER_START,
} from '../../actions/item'

/**
 * get list item user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListItemUserApi = (props) => {
  var uri = `/users/items`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListItemUser(action) {
  try {
    const response = yield call(getListItemUserApi, action?.payload)
    yield put(getAllItemUserSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllItemUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list item user
 */
export default function* watchGetListItemUser() {
  yield takeLatest(GET_ALL_ITEM_USER_START, doGetListItemUser)
}
